window.$ = window.jQuery = require('jquery')

export default function menuBtn() {
  $(() => {
    const $btn = $('.sk-gnav__btn')
    const $list = $('#header-menu')
    const $trigger = $('.sk-gnav__trigger')
    $btn.on('click', function () {
      $trigger.toggleClass('sk-active')
      $list.slideToggle()
      return false
    })
  })
}
